export default __webpack_public_path__ + "static/media/Cootie (2191).97d1eb8c.jpg";